import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, BehaviorSubject} from 'rxjs';
import {PropertiesService} from './properties.service';
import {NazioniResponse, DocumentiResponse, GDPR} from "../interfaces/utilities";
import { CasaDiscografica, CaseDiscograficheResponse } from '../interfaces/record-company';
import { Utente, Profilo } from '../interfaces/user';
import { CreazioneUtenteResponse } from '../interfaces/juror';


@Injectable({
	providedIn: 'root'
})
export class UsersService {
    
    currentUser = new BehaviorSubject<Profilo>(null);
	private _subCurrent = this.currentUser.subscribe(data=>{
		if(data !== null){
			return data;
		}
	});

    constructor(private http: HttpClient, private propService: PropertiesService) { }


    getProfile(): Observable<any> {
		return this.http.get<any>(this.propService.getProp('apiPrefix') + '/api/Public/Utente/Profilo');
	}
	
	getGdpr() : Observable<GDPR> {
		return this.http.get<GDPR>(this.propService.getProp('apiPrefix')+'/api/Public/Servizi/GdprTesto');
	}
    
	getRecordCompaniesList():Observable<CaseDiscograficheResponse> {
		return this.http.get<CaseDiscograficheResponse>(this.propService.getProp('apiPrefix') + '/api/Public/CaseDiscografiche/Lista');
	}

	createExternalUser(user:Utente): Observable<CreazioneUtenteResponse> {
		return this.http.post<CreazioneUtenteResponse>(this.propService.getProp('apiPrefix')+'/api/Public/Utente/CreazioneUtente', user);
	}

	getNations() : Observable<NazioniResponse> {
        return this.http.get<NazioniResponse>(this.propService.getProp('apiPrefix')+'/api/Public/Servizi/ListaNazioni');
	}
	
	getDocumentTypes() : Observable<DocumentiResponse> {
        return this.http.get<DocumentiResponse>(this.propService.getProp('apiPrefix')+'/api/Public/Servizi/ListaDocumenti');
    }
}